// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"overlay_overlayWrapper__JSzHC","errorBox":"overlay_errorBox__cMDm5"};